<template>
  <div class="support">
    <div class="section-background">
      <div class="container">
        <div class="hero">
          <div class="text">
            <p class="sub-title">
              Answers to your questions
            </p>
            <h1 class="title">
              FAQ
            </h1>
            <div
              v-b-toggle.collapse-1
              class="FAQ-question"
            >
              <b>Who has access to my data?</b>
            </div>
            <b-collapse
              id="collapse-1"
              class="FAQ-answer"
            >
              <div>
                Your data will remain safe within our cloud environment. Coaches
                assigned to your team will have access to your videos only to
                review and provide feedback.
              </div>
            </b-collapse>
            <div
              v-b-toggle.collapse-2
              class="FAQ-question"
              variant="primary"
            >
              <b>What happens after I upload a video?</b>
            </div>
            <b-collapse
              id="collapse-2"
              class="FAQ-answer"
            >
              <div>
                After a successful video upload, our Smart Algorithm will pick
                up your video and automatically extract key highlights from your
                batting video. After successful processing, we will notify the
                corresponding coaches.
              </div>
            </b-collapse>

            <div
              v-b-toggle.collapse-3
              class="FAQ-question"
              variant="primary"
            >
              <b> Can I ask questions to my coach about their feedback?</b>
            </div>
            <b-collapse
              id="collapse-3"
              class="FAQ-answer"
            >
              <div>
                Yeah, we encourage you to start a conversation with your coach
                to get into details of their feedback. Your coach will be
                notified and will respond to your questions at this convenience.
              </div>
            </b-collapse>

            <div
              v-b-toggle.collapse-4
              class="FAQ-question"
              variant="primary"
            >
              <b> How can I build my player profile?</b>
            </div>
            <b-collapse
              id="collapse-4"
              class="FAQ-answer"
            >
              <div>
                It is very important that you upload your training videos on a
                regular basis. We recommend uploading at least 1 video per week
                of 10 minutes of your batting, bowling or fielding drills. Your
                coach will have more data to understand your skills and help
                him/her to personalise training programs just for you so that
                you improve real fast.
              </div>
            </b-collapse>

            <div
              v-b-toggle.collapse-5
              class="FAQ-question"
              variant="primary"
            >
              <b>
                As a coach, how can I provide feedback to my athletes videos?</b>
            </div>
            <b-collapse
              id="collapse-5"
              class="FAQ-answer"
            >
              <div>
                Ludimos provides three different ways to provide feedback.
                <ul>
                  <li>
                    Text Feedback - Just pick any frame from a video and type in
                    your feedback, drills, messages, etc.
                  </li>
                  <li>
                    Visual Feedback* - Use our drawing tools to further annotate
                    and add context to text feedback.
                  </li>
                  <li>
                    Audio Feedback* - Even further, just record your feedback up
                    to 30 seconds as an audio note and attach to player profile.
                  </li>
                </ul>
                *This feature is not available in few devices and browsers.
              </div>
            </b-collapse>

            <div
              v-b-toggle.collapse-6
              class="FAQ-question"
              variant="primary"
            >
              <b>
                I have 2 coaches at my club. Can both of them review my videos
                and provide feedback?</b>
            </div>
            <b-collapse
              id="collapse-6"
              class="FAQ-answer"
            >
              <div>
                YES! That is the added value of using Ludimos. A video can be
                reviewed by any number of coaches provided they are give access
                either by you or by your club/academy administrators.
                <br>This makes it easier for you to learn from multiple
                coaches at the same time, collecting value inputs about your
                batting and bowling skills.
              </div>
            </b-collapse>

            <div
              v-b-toggle.collapse-7
              class="FAQ-question"
              variant="primary"
            >
              <b>
                Can I delete my video? What will happen to received feedback?</b>
            </div>
            <b-collapse
              id="collapse-7"
              class="FAQ-answer"
            >
              <div>
                You can delete videos that you personally uploaded to Ludimos.
                You can use the delete icon on video player page to delete your
                video.
                <br>Keep in mind that this action cannot be undone and any
                feedback that you have received will be lost from your profile.
              </div>
            </b-collapse>

            <div
              v-b-toggle.collapse-8
              class="FAQ-question"
              variant="primary"
            >
              <b>
                As a Club Administrator, Can I see an overview of all videos
                uploaded and feedback?</b>
            </div>
            <b-collapse
              id="collapse-8"
              class="FAQ-answer"
            >
              <div>
                Definitely yes! We provide both higher level overview of number
                of players uploading videos and feedback provided by coaches.
                <br>Within the performance tab of a team, you will be able to
                see,
                <ul>
                  <li>
                    Daily, weekly and monthly video upload trends of players
                  </li>
                  <li>Feedback breakdown charts</li>
                  <li>Member information with their role in this team</li>
                </ul>
                We are constantly working towards adding more metrics that adds
                value to you, so if you have any specific needs, please feel
                free to reach us at
                <a href="mailto:hello@ludimos.com">hello@ludimos.com</a>
              </div>
            </b-collapse>

            <div
              v-b-toggle.collapse-9
              class="FAQ-question"
              variant="primary"
            >
              <b> Video upload fails! What should I do? </b>
            </div>
            <b-collapse
              id="collapse-9"
              class="FAQ-answer"
            >
              <div>
                Don't panic! Contact us at
                <a href="mailto:hello@ludimos.com">hello@ludimos.com</a>. We
                will guide you to get your video uploaded.
              </div>
            </b-collapse>
          </div>
          <div class="visual">
            <div class="background">
              <img
                src="../assets/img/hero-background.svg"
                alt="background visual"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Support",
  mounted() {
    this.$ma.trackEvent({
      fb_event: "ViewContent",
      category: "Menu",
      action: "Menu",
      label: "Support",
      type: "Support",
    });
  },
  metaInfo() {
    return {
      title: this.textEllipsis(`Ludimos - FAQ`, 25),
      // meta: [{ name: "theme-color", content: this.getPrimaryHex }]
    };
  },
};
</script>
<style lang="scss" scoped>
.FAQ-question {
  cursor: pointer;
  border-bottom: 1px solid #eee;
  padding: 10px 0 10px 30px;
  position: relative;
  &:before {
    content: "keyboard_arrow_up";
    font-family: "Material Icons";
    position: absolute;
    left: 5px;
    top: 6px;
    font-size: 20px;
  }
  &.collapsed {
    &:before {
      content: "keyboard_arrow_down";
    }
  }

  span {
    display: block;
    opacity: 0.7;
    font-size: 12px;
  }
}
.FAQ-answer {
  > div {
    padding: 20px;
    margin: 0;
    background: #f5f5f5;
  }
}
@media (max-width: 767px) {
  iframe {
    height: 200px;
  }
}
</style>
